<div class="content-wrapper" *ngIf="company">
    <div class="card">
      <div class="card-body">
        <div class="row separator ">
            <div class="col-md-12">
                <h4 class="card-title">Automation</h4>
            </div>
        </div>
        <form #automationForm="ngForm">
            <div class="row ">
                <div class="col-md-12 separator_light">
                    <div class="permission_value">
                        <mat-slide-toggle
                        class="example-margin"
                        (change)="setValue('attendanceAutomation', $event)"
                        [checked]="company.attendanceAutomation == 1">
                        Attendance Email Reminder ( Send to Barrister after the court date date. Date and Time is Every Monday and Thursday at 5:00pm)
                    </mat-slide-toggle>
                    </div>
                </div>
                <div class="col-md-12 separator_light">
                    <div class="permission_value">
                        <mat-slide-toggle
                        class="example-margin"
                        (change)="setValue('outstandingAutomation', $event)"
                        [checked]="company.outstandingAutomation ==1">
                        Outstanding Document Reminder ( Send to Solicitor soon after adding the case till the court start date.  Transmission will be done everyday at 10:00am)
                    </mat-slide-toggle>
                    </div>
                </div>
                <div class="col-md-12 separator_light">
                    <div class="permission_value">
                        <mat-slide-toggle
                        class="example-margin"
                        (change)="setValue('invoiceAutomation', $event)"
                        [checked]="company.invoiceAutomation ==1">
                        Invoice Reminder ( Send to Solicitor after 5 days of the court end date.  Transmission will be done everyday at 10:00am)
                    </mat-slide-toggle>
                    </div>
                </div>
                <div class="col-md-12 separator_light">
                    <div class="permission_value">
                        <mat-slide-toggle
                        class="example-margin"
                        (change)="setValue('emailSolicitor', $event)"
                        [checked]="company.emailSolicitor ==1">
                        New Case Entry Notification to Solicitor ( Send to Solicitor As soon as the case saved in the database.)
                    </mat-slide-toggle>
                    </div>
                </div>
                <div class="col-md-12 separator_light">
                    <div class="permission_value">
                        <mat-slide-toggle
                        class="example-margin"
                        (change)="setValue('emailBarrister', $event)"
                        [checked]="company.emailBarrister ==1">
                        New Case Entry Notification to Barrister ( Send to Barrister As soon as the case saved in the database.)
                    </mat-slide-toggle>
                    </div>
                </div>
        </div>
        <div class="field-separator"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="button-row">
                    <button  class="btn btn-primary btn-block" (click)="updateAutomation(automationForm.value)">Update Now</button>
                </div>
            </div>
        </div>
      </form>
    </div>
  </div>
</div>

